import { React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { FormContext } from './form-context';

class Context extends React.Component {
  render() {
    const { children, ...props } = this.props;
    return (
      <FormContext.Provider value={{ ...props }}>
        {children}
      </FormContext.Provider>
    );
  }
}

Context.contextType = FormContext;

Context.propTypes = {
  fieldProps: PropTypes.object,
  children: PropTypes.any,
};

Context.defaultProps = {};

export { Context };
